<template>
  <tr>
    <td>
      <router-link
        :to="{
          name: 'single_role',
          params: { id: props.item.id }
        }"
      >
        {{ props.item.name }}
      </router-link>
    </td>

    <td>
      {{ props.item.code }}
    </td>
  </tr>
</template>

<script>
export default {
  name: 'RoleDataTableRow',

  props: {
    props: {
      type: Object,
      required: true
    }
  }
}
</script>
